export default {
  init() {
    // JavaScript to be fired on the home page

    $('.our-projects__projects-box').slick({
      draggable: false,
      infinite: false,
      centerMode: true,
      prevArrow: $('.project-navigation-box__left-arrow'),
      nextArrow: $('.project-navigation-box__right-arrow'),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            centerMode: false,
          },
        },
      ],
    });

    function updateNumber() {
      $('.current-project-number').text($('.slick-current').data('slick-index') + 1);
    }

    $('.project-navigation-box__left-arrow').on('click', updateNumber);
    $('.project-navigation-box__right-arrow').on('click', updateNumber);
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
